module.exports = __webpack_public_path__ + "media/icons/menu-a268186e.svg";